import React from 'react';

import {checkIfHasPermissions} from '../../../components/Menu/Utils/commonFunctions';
import PageContent from '../../../components/PageContent/PageContent';
import Tabs from '../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../constants/permissionsEnum';
import TranslatedText from '../../../libraries/I18N/TranslatedText';

import EFDatabase from './utils/EFDatabase/EFDatabase';

// import UserManagement from './utils/userManagement/UserManagement';

const DataManagement: React.FC = () => {
  const orgFac = [
    {
      id: 'EFDatabase',
      name: <TranslatedText translationKey="Emission Factor Databases" />,
      component: <EFDatabase />,
      hidden: !checkIfHasPermissions(
        PermissionEnum.ConfiguratorEmissionFactorDatabase
      )
    }
    // {
    //   id: 'userManagement',
    //   name: <TranslatedText translationKey="User Manager" />,
    //   component: <UserManagement />
    // }
  ].filter((el) => !el.hidden);

  return (
    <PageContent fullscreen={false}>
      <Tabs array={orgFac} noPadding />
    </PageContent>
  );
};

export default DataManagement;
